import React from 'react';
import PropTypes from 'react-proptypes';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

/* eslint-disable react/no-children-prop */

export const SortHandle = SortableHandle(({ children }) => children);
export const SortElement = SortableElement(({ children }) => children);
export const SortContainer = SortableContainer(({ children, wrapper = 'div' }) => React.createElement(wrapper, { children }), { withRef: true });

SortHandle.propTypes = { children: PropTypes.node };

SortElement.propTypes = { children: PropTypes.node };

SortElement.propTypes = {
  children: PropTypes.node,
  // @ts-ignore
  wrapper: PropTypes.string.isRequired,
};
